export const calculateTotalMinutes = (hours, minutes) => {
  if (!hours && minutes === 0) return 0;
  if (!hours && (minutes === null || minutes === undefined || minutes === '')) return '';
  if (!hours) hours = 0;
  return (Number(hours) * 60) + Number(minutes);
}

export const calculateHoursFromTotalMinutes = (totalMinutes) => {
  if (!totalMinutes) return;
  return Math.floor(totalMinutes / 60);
}

export const calculateRemainingMinutesFromTotalMinutes = (totalMinutes) => {
  if (totalMinutes === 0) return 0;
  if (!totalMinutes) return;
  return totalMinutes % 60;
}

export const calculateNumberOfYearsAgo = (year) => {
  const numericYear = typeof year === 'string' ? parseInt(year, 10) : year;
  const currentYear = new Date().getFullYear();
  const yearsAgo = currentYear - numericYear;
  return yearsAgo;
};

export const calculateMyAgeOnThisDate = (date) => {
  if (!(date instanceof Date)) date = new Date(date);
  const dateBorn = new Date('1981-03-17');
  let age = date.getFullYear() - dateBorn.getFullYear();

  // Adjust if the birthday hasn't occurred yet that year
  const hasHadBirthday = date.getMonth() > dateBorn.getMonth() || (date.getMonth() === dateBorn.getMonth() && date.getDate() >= dateBorn.getDate());
  if (!hasHadBirthday) age -= 1;
  return age;
};
